import { get, post, del } from '@chilipiper/service/src/api-v2'
import { CreateSingleUseLinkPayload } from '@chilipiper/api-type-def'
import { SingleUseLink } from '@chilipiper/api-type-def/src/bookingLinks'
import {
  AdminGroupBookingLinksResponse,
  AdminIndividualBookingLinkResponse,
  AdminIndividualBookingLinksResponse,
  AllRequest,
  ApiBookingLink,
  SaveRequest,
} from '../types'

export const bookingLinkService = {
  adminIndividual(workspaceId: string, page = 0, pageSize = 10) {
    return get('bookinglinks/admin/individual', {
      searchParams: { workspaceId, page, pageSize },
    }).json<AdminIndividualBookingLinksResponse>()
  },
  adminIndividualTemplate(workspaceId: string, templateId: string, page = 0, pageSize = 10) {
    return get('bookinglinks/admin/individual-template', {
      searchParams: { workspaceId, templateId, page, pageSize },
    }).json<AdminIndividualBookingLinkResponse>()
  },
  adminGroup(workspaceId: string, page = 0, pageSize = 10) {
    return get('bookinglinks/admin/group', {
      searchParams: { workspaceId, page, pageSize },
    }).json<AdminGroupBookingLinksResponse>()
  },
  all(search: AllRequest = {}) {
    const { workspaceId, userId } = search
    const searchParams: AllRequest = {}

    if (search.workspaceId) {
      searchParams.workspaceId = workspaceId
    }

    if (search.userId) {
      searchParams.userId = userId
    }

    const options = Object.keys(searchParams).length ? { searchParams } : undefined

    return get(`bookinglinks`, options as any).json<ApiBookingLink[]>()
  },
  groupById(groupId: string) {
    return get(`bookinglinks/group/${groupId}`).json<ApiBookingLink>()
  },
  groupSave(workspaceId: string, request: SaveRequest) {
    return post(`bookinglinks/group`, {
      json: { ...request, workspaceId },
    }).json<ApiBookingLink>()
  },
  groupDel(groupId: string) {
    return del(`bookinglinks/group/${groupId}`).json<{ success: true }>()
  },
  individualLink(templateId: string) {
    return get(`bookinglinks/individual`, {
      searchParams: {
        templateId,
      },
    }).json<ApiBookingLink>()
  },
  singleUseLink(params: CreateSingleUseLinkPayload) {
    return post('bookinglinks/singleuse', { json: params }).json<SingleUseLink>()
  },
}
